/**
 * Custom hook to check if the current page is embedded in an app
 * @returns True if the current page is embedded in an app, false otherwise
 */
export const useIsEmbedded = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("embed") === "true";
};

export default useIsEmbedded;
